import { AvailableServices, HelproomsNamespaces, HotlinesNameSpaces, ResourcesNameSpaces, RHSPermissions, WorkspacesNamespaces } from 'packages/workspace/modules/algebra/constants';
import type { Actions, Subjects } from 'packages/workspace/modules/helpers/contexts';
/**
 * System Related Config
 */
export const SystemConfig = {
  SUCCESS_CODE: 200,
  FORBIDDEN: 403,
  ARRAY_LENGTH_ZERO: 0,
  LENGTH_MINUS_ONE: 1,
  PRODUCTION: 'production',
  STALE_TIME: 3600000,
  ONE_MINUTE: 36000,
};

/**
 * TimeOutConfigs
 */
export const TimeOutConfigs = {
  MINIMUM_INTERVAL: 1500,
  TWO_SECONDS: 2000,
};

/**
 * Configuraation Needed for ALl Widgets
 */
export const WidgetConfig = {
  INITIAL_TAB_STATE: 0,
  FIRST_TAB: 1,
  SECOND_TAB: 2,
  THIRD_TAB: 3,
  FOURTH_TAB: 4,
};

/**
 * Configuration Related to Auth
 */

export const AuthConfig = {
  COOKIE_POLICY: 'lax',
  COOKIE_PATH: '/',
  EXPIRES_AT: 365,
  MAX_AGE: 86400,
  COGNITO_AUTHENTICATION_TYPE: 'CUSTOM_AUTH',
};

/**
 * General Messages
 */
export const MessageKeyConfig = {
  SERVER_ERROR_SOMETHING_WENT_WRONG: 'Something Went Wrong !',
};

/**
 * Task router Config.
 */
export const TaskRouterConfig = {
  MINIMUM_CHARS_TO_SHOW_ON_TASKS_LIST: 30,
  RESERVED_STATUS: 'reserved',
  ONE_SECOND_INTERVAL: 1000,
  WRAPPING_STATUS: 'wrapping',
  ASSIGNED: 'assigned',
};

/**
 * Queue contstants
 */
export const QueueConfig = {
  LAST_MINIMUM_CHARACTERS_TO_SHOW: -5,
};

/***
 * Audio COnfig
 */

export const AudioConfig = {
  MAXIMUM_SOUND: 1.0,
};

/**
 * OAuthConfig
 */
export const OAuthConfig = {
  OAuthProviders: [
    {
      src: '/logo-gmail.png',
      alt: 'Login Via Google',
      width: '100',
      height: '100',
      type: 'Google',
      securityKey: 'security_authentication_via_google_enabled',
    },
    {
      src: '/logo-apple.png',
      alt: 'Login Via AppleId',
      width: '120',
      height: '120',
      type: 'SignInWithApple',
      securityKey: 'security_authentication_via_apple_enabled',
    },
    {
      src: '/logo-microsoft.png',
      alt: 'Login Via Microsoft',
      width: '120',
      height: '120',
      oauth_type: 'custom', //Microsoft OOB Login is not provided by AMplify
      securityKey: 'security_authentication_via_microsoft_enabled',
    },
  ],
};

/**
 * Internal Chat Config
 */
export const InternalChatConfig = {
  NEW_REQUEST: 'newRequest',
};

export const WorkspaceTabs: Array<{
  id: string;
  title: string;
  route: string;
  can: {
    do: Actions;
    on: Subjects;
  };
}> = [
    {
      id: 'tab-clients',
      title: 'Clients',
      route: '/console/clients.page',
      can: {
        do: RHSPermissions.LIST,
        on: WorkspacesNamespaces.CLIENTS,
      },
    },
    {
      id: 'tab-access-management',
      title: 'Access Management',
      route: '/console/access-management/accounts.page',
      can: {
        do: RHSPermissions.LIST,
        on: WorkspacesNamespaces.ACCOUNTS,
      },
    },
    {
      id: 'tab-approve-new-requests',
      title: 'Approve New Requests',
      route: '/console/access-management/accounts.request',
      can: {
        do: RHSPermissions.LIST,
        on: WorkspacesNamespaces.ACCOUNTS,
      },
    },
    {
      id: 'tab-calls',
      title: 'Internal onCall',
      route: '/console/onCalls/calls.page',
      can: {
        do: RHSPermissions.LIST,
        on: WorkspacesNamespaces.INTERNAL_ONCALLS,
      },
    },
    {
      id: 'tab-admin-lines',
      title: 'Admin Lines',
      route: '/console/admin-lines/admin-lines.page',
      can: {
        do: RHSPermissions.LIST,
        on: WorkspacesNamespaces.ADMIN_LINES,
      },
    },

    {
      id: 'tab-admin-lines-logs',
      title: 'Admin Lines Logs',
      route: '/console/admin-lines/admin-lines-logs.page',
      can: {
        do: RHSPermissions.LIST,
        on: WorkspacesNamespaces.ADMIN_LINES_LOGS,
      },
    },
    {
      id: 'tab-settings',
      title: 'Settings',
      route: '/console/settings/settings.page',
      can: {
        do: RHSPermissions.UPDATE,
        on: WorkspacesNamespaces.WORKSPACES,
      },
    },
  ];

export const ResourcesTabs: Array<{
  id: string;
  title: string;
  route: string;
  can: {
    do: Actions;
    on: Subjects;
  };
}> = [
    {
      id: 'tab-documents',
      title: 'Documents',
      route: '/console/resources/documents',
      can: {
        do: RHSPermissions.LIST,
        on: ResourcesNameSpaces.DOCUMENT_BUCKETS,
      },
    },
    {
      id: 'tab-resources-form',
      title: 'Forms',
      route: '/console/resources/forms',
      can: {
        do: RHSPermissions.LIST,
        on: ResourcesNameSpaces.FORM_BUCKETS,
      },
    },
    {
      id: 'tab-cms',
      title: 'CMS',
      route: '/console/resources/cms',
      can: {
        do: RHSPermissions.LIST,
        on: ResourcesNameSpaces.CMS_BUCKETS,
      },
    },
    {
      id: 'tab-logs',
      title: 'Logs',
      route: '/console/resources/logs',
      can: {
        do: RHSPermissions.LIST,
        on: ResourcesNameSpaces.DOCUMENT_BUCKETS,
      },
    },
  ];

export const getHotlinetabs = (appId: string) => [
  {
    id: 'tab-channels',
    title: 'Channels',
    route: `/console/hotlines/channels?appId=${appId}`,
  },

  {
    id: 'tab-task-routing',
    title: 'Task Routing',
    route: `/console/hotlines/task-routing/phone-numbers?appId=${appId}`,
  },
  {
    id: 'tab-profile',
    title: 'Profiles',
    route: `/console/hotlines/profile?appId=${appId}`,
  },
  {
    id: 'tab-catalog',
    title: 'Catalogues',
    route: `/console/hotlines/catalogs?appId=${appId}`,
  },

  {
    id: 'tab-log',
    title: 'Logs',
    route: `/console/hotlines/log/shifts?appId=${appId}`,
  },
  {
    id: 'tab-on-calls',
    title: 'On Calls',
    route: `/console/hotlines/on-calls?appId=${appId}`,
  },
  {
    id: 'tab-block-numbers',
    title: 'Blocked Numbers',
    route: `/console/hotlines/blocked-numbers?appId=${appId}`,
  },
  {
    id: 'tab-do-not-block-numbers',
    title: 'Do Not Block Numbers',
    route: `/console/hotlines/do-not-block-numbers?appId=${appId}`,
  },
  {
    id: 'tab-lists',
    title: 'Lists',
    route: `/console/hotlines/lists?appId=${appId}`,
  },
  {
    id: 'tab-announcements',
    title: 'Announcements',
    route: `/console/hotlines/announcements?appId=${appId}`,
  },
  {
    id: 'tab-keywords',
    title: 'Keywords',
    route: `/console/hotlines/keywords?appId=${appId}`,
  },
  {
    id: 'tab-annotations',
    title: 'Annotations',
    route: `/console/hotlines/annotations?appId=${appId}`,
  }
];

export const getHelproomtabs = (appId: string) => [
  {
    id: 'tab-helprooms',
    title: 'HelpRooms',
    route: `/console/helproom/metadata/ingress?appId=${appId}`,
  },
  {
    id: 'tab-channels',
    title: 'Channels',
    route: `/console/helproom/channels/channels?appId=${appId}`,
  },

  {
    id: 'tab-metadata',
    title: 'Metadata',
    route: `/console/helproom/metadata/service-keys?appId=${appId}`,
  },
  {
    id: 'tab-profiles',
    title: 'Profiles',
    route: `/console/helproom/metadata/operator-profile?appId=${appId}`,
  },
  {
    id: 'tab-resources',
    title: 'Catalogues',
    route: `/console/helproom/resources?appId=${appId}`,
  },
  {
    id: 'tab-logs',
    title: 'Logs',
    route: `/console/helproom/log/shift-logs?appId=${appId}`,
  },
];

export const getTaskRoutingTabs = (appId: string) => ({
  'Phone Numbers': `/console/hotlines/task-routing/phone-numbers?appId=${appId}`,
  'Message Service Keys': `/console/hotlines/task-routing/chat-service-keys?appId=${appId}`,
  Skills: `/console/hotlines/task-routing/skills?appId=${appId}`,
  Queues: `/console/hotlines/task-routing/queues?appId=${appId}`,
  People: `/console/hotlines/task-routing/staff?appId=${appId}`,
  Workflows: `/console/hotlines/task-routing/workflows?appId=${appId}`,
  Endpoints: `/console/hotlines/task-routing/endpoints?appId=${appId}`,
  Groups: `/console/hotlines/task-routing/groups?appId=${appId}`,
});

export const getHelproomMetadataTabs = (appId: string) => ({
  'Service Keys': `/console/helproom/metadata/service-keys?appId=${appId}`,
  Skills: `/console/helproom/metadata/skills?appId=${appId}`,

  Operators: `/console/helproom/metadata/operators?appId=${appId}`,
  Endpoints: `/console/helproom/metadata/endpoints?appId=${appId}`,
  Schedules: `/console/helproom/metadata/schedules?appId=${appId}`,
});

export const getHelproomChannelTabs = (appId: string) => ({
  Channels: `/console/helproom/channels/channels?appId=${appId}`,
  'Channel Types': `/console/helproom/channels/channel-types?appId=${appId}`,
});

export const BottomPanelTypes = {
  SUPPORT_CENTER: 'SUPPORT_CENTER',
  ADVOCATES_SERVICES: 'ADVOCATES_SERVICES',
  LISTS: 'LISTS',
};

export const getLogTabs = (appId: string) => ({
  Shifts: `/console/hotlines/log/shifts?appId=${appId}`,
  Tasks: `/console/hotlines/log/tasks?appId=${appId}`,
  Logs: `/console/hotlines/log/logs?appId=${appId}`,
});

export const getHelpRoomLogTabs = (appId: string) => ({
  Shifts: `/console/helproom/log/shift-logs?appId=${appId}`,
  Logs: `/console/helproom/log/logs?appId=${appId}`,
});

export const getAccessManagementTabs = () => ({
  Accounts: '/console/access-management/accounts.page',
  Groups: '/console/access-management/groups.page',
  Roles: '/console/access-management/roles.page',
  Policies: '/console/access-management/policies.page',
  'Iam Logs': '/console/access-management/iamlogs',
  'Platform Logs': '/console/access-management/platformlogs',
});

export function msToTime(duration: number): string {
  const secondsInMinute = 60;
  const minutesInHour = 60;
  const hoursInDay = 60;
  const miliseconds = 1000;
  const showZero = 10;

  const minutes = parseInt((duration / (secondsInMinute * miliseconds)) % minutesInHour);
  const hours = parseInt((duration / (miliseconds * secondsInMinute * minutesInHour)) % hoursInDay);

  return `${hours < showZero ? `0${hours}` : hours}:${minutes < showZero ? `0${minutes}` : minutes}`;
}

export const WeekOptions = [
  { title: 'SU', value: 'Sunday' },
  { title: 'MO', value: 'Monday' },
  { title: 'TU', value: 'Tuesday' },
  { title: 'WE', value: 'Wednesday' },
  { title: 'TH', value: 'Thursday' },
  { title: 'FR', value: 'Friday' },
  { title: 'SA', value: 'Saturday' },
];

export const WorkspacePermissions = [
  {
    service: AvailableServices.HOTLINES,
    namespace: HotlinesNameSpaces.APPS,
  },
  {
    service: AvailableServices.HELPROOMS,
    namespace: HelproomsNamespaces.HELPROOMS_APPS,
  },
  {
    service: AvailableServices.WORKSPACES,
    namespace: WorkspacesNamespaces.CLIENTS,
  },
  {
    service: AvailableServices.WORKSPACES,
    namespace: WorkspacesNamespaces.ACCOUNTS,
  },
  {
    service: AvailableServices.WORKSPACES,
    namespace: WorkspacesNamespaces.INTERNAL_ONCALLS,
  },
  {
    service: AvailableServices.WORKSPACES,
    namespace: WorkspacesNamespaces.WORKSPACES,
  },
  {
    service: AvailableServices.WORKSPACES,
    namespace: WorkspacesNamespaces.ADMIN_LINES,
  },
  {
    service: AvailableServices.WORKSPACES,
    namespace: WorkspacesNamespaces.ADMIN_LINES_LOGS,
  },
  {
    service: AvailableServices.RESOURCES,
    namespace: ResourcesNameSpaces.DOCUMENT_BUCKETS,
  },
  {
    service: AvailableServices.RESOURCES,
    namespace: ResourcesNameSpaces.CMS_BUCKETS,
  },
  {
    service: AvailableServices.RESOURCES,
    namespace: ResourcesNameSpaces.FORM_BUCKETS,
  },
  {
    service: AvailableServices.RESOURCES,
    namespace: ResourcesNameSpaces.LOGS,
  },
  {
    service: AvailableServices.WORKSPACES,
    namespace: WorkspacesNamespaces.ACCOUNTS_PASSWORD,
  },
  {
    service: AvailableServices.WORKSPACES,
    namespace: WorkspacesNamespaces.WORKSPACE_MEMBERS,
  },
  {
    service: AvailableServices.WORKSPACES,
    namespace: WorkspacesNamespaces.GROUPS,
  },
  {
    service: AvailableServices.WORKSPACES,
    namespace: WorkspacesNamespaces.LOGS,
  },
  {
    service: AvailableServices.WORKSPACES,
    namespace: WorkspacesNamespaces.POLICIES,
  },
  {
    service: AvailableServices.WORKSPACES,
    namespace: WorkspacesNamespaces.ROLES,
  },
];
